import React from 'react';
import SuiviHeader from '../../../composants/SuiviHeader/SuiviHeader';
import { getStatusColor } from '../../../utils/entityUtils';
import { CommandeMS } from '../types';

interface CommandeMsHeaderProps {
  titre: string;
  sousTitre: string;
  subtitle: string;
  commande: CommandeMS;
  backgroundImage?: string;
}

// Banniere prestataire-MS : delegue au generique SuiviHeader (source="MS"), MEME composant et MEME
// rendu DOM que l'oracle (SuiviDeCommande.tsx:924-932) -> parite VISUELLE exacte. L'expiration est
// calculee EN INTERNE par id (statusId) ; la couleur de la pastille reste presentationnelle (par
// nom via getStatusColor, comme l'oracle).
//
// Dette assumee (charte §5) : SuiviHeader est un composant partage. On le garde ici comme cote BC
// presta (CommandeHeader, source="BC") pour ne pas descendre sous l'autonomie de la case soeur ;
// il sera forke quand le header de toute la filiere presta sera refait. Le gating, lui, est deja
// 100% id-based dans le domaine.
const CommandeMsHeader: React.FC<CommandeMsHeaderProps> = ({
  titre,
  sousTitre,
  subtitle,
  commande,
  backgroundImage,
}) => (
  <SuiviHeader
    titre={titre}
    sousTitre={sousTitre}
    nomOuvrage={commande.operation?.nom_ouvrage || undefined}
    subtitle={subtitle}
    status={commande.status?.nom || 'Statut inconnu'}
    statusColor={getStatusColor(commande.status?.nom || '')}
    delais={commande.expire_at ?? commande.operation?.expire_at ?? undefined}
    backgroundImage={backgroundImage}
    source="MS"
    statusId={commande.status?.id}
    encart={{
      operationId: commande.operation?.id,
      numeroMarche: String(commande.operation?.numero ?? ''),
      sensibilite: commande.operation?.niveau_sensibilite
        ? String(commande.operation.niveau_sensibilite)
        : null,
    }}
  />
);

export default CommandeMsHeader;
